import {tokens} from '@commercial-helios/ui/theme'
import styled, {css} from 'styled-components'

import {Section} from '@helios/shared/styles/grid'
import {TextLink} from '@helios/shared/styles/typography'
import mq from '@helios/shared/utils/media-query'

export const ShowMore = styled(TextLink).attrs({as: 'button'})`
    grid-column: 1 / -1;
    justify-self: center;
`

export const CardsSection = styled(Section)`
    display: grid;
    row-gap: ${tokens.spacing60};
`

interface CardsGridProps {
    mobileLimit: number
    desktopLimit: number
    totalCards: number
}

export const CardsGrid = styled.div<CardsGridProps>(({mobileLimit, desktopLimit, totalCards}) => {
    const bp = 'md'

    const hide = css`
        display: none;
    `

    return css`
        ${mq.max(bp)} {
            ${ShowMore} {
                ${mobileLimit >= totalCards && hide}
            }

            > :nth-child(n + ${mobileLimit + 1}):not(${ShowMore}) {
                ${hide}
            }
        }

        ${mq.min(bp)} {
            ${ShowMore} {
                ${desktopLimit >= totalCards && hide}
            }

            > :nth-child(n + ${desktopLimit + 1}):not(${ShowMore}) {
                ${hide}
            }
        }
    `
})
